export default "__VITE_ASSET__CcXbsg44__"